import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import { getConsent, saveConsent, loadAnalytics, captureAttribution } from "@/lib/tracking";
import { useSettings } from "@/lib/api";

export const CookieConsent = () => {
  const settings = useSettings();
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    const c = getConsent();
    if (!c) setOpen(true); else setPrefs({ analytics: !!c.analytics, marketing: !!c.marketing });
    const reopen = () => { setOpen(true); setManage(true); };
    window.addEventListener("dad-open-consent", reopen);
    return () => window.removeEventListener("dad-open-consent", reopen);
  }, []);

  useEffect(() => { captureAttribution(); loadAnalytics(settings); }, [settings]);

  const save = (p) => { saveConsent(p); setPrefs(p); setOpen(false); captureAttribution(); loadAnalytics(settings); };
  if (!open) return null;

  return (
    <div role="dialog" aria-label="Cookie preferences" data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-20 z-[55] mx-auto max-w-md rounded-3xl border border-violet-200 bg-white p-5 shadow-[0_30px_80px_-20px_rgba(19,5,42,.45)] md:bottom-6 md:left-6 md:right-auto md:mx-0">
      <p className="text-base font-extrabold text-[#13052A]">Your privacy, your choice</p>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">
        We use essential storage to run this site. With your permission we'd also like to use analytics and marketing cookies. <Link to="/cookie-policy" className="font-semibold text-[#581C87] underline">Cookie Policy</Link>
      </p>
      {manage && (
        <div className="mt-4 space-y-3 rounded-2xl bg-[#F5F0FF] p-4">
          <p className="flex items-center justify-between gap-4 text-sm font-semibold text-[#13052A]" data-testid="consent-essential">
            Essential (needed for the site to work) <span className="text-xs font-bold text-[#581C87]">Always on</span>
          </p>
          {[["analytics", "Analytics (GA4 / Tag Manager)"], ["marketing", "Marketing (Meta Pixel)"]].map(([k, label]) => (
            <label key={k} className="flex items-center justify-between gap-4 text-sm font-semibold text-[#13052A]">
              {label}
              <Switch checked={prefs[k]} onCheckedChange={(v) => setPrefs((p) => ({ ...p, [k]: v }))} data-testid={`consent-toggle-${k}`} />
            </label>
          ))}
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <button onClick={() => save({ analytics: true, marketing: true })} className="btn-primary !px-5 !py-2.5" data-testid="consent-accept-all">Accept all</button>
        <button onClick={() => save({ analytics: false, marketing: false })} className="btn-ghost !px-5 !py-2.5" data-testid="consent-reject-all">Reject non-essential</button>
        {manage ? (
          <button onClick={() => save(prefs)} className="btn-ghost !px-5 !py-2.5" data-testid="consent-save">Save choices</button>
        ) : (
          <button onClick={() => setManage(true)} className="px-2 text-sm font-semibold text-[#581C87] underline" data-testid="consent-manage">Manage</button>
        )}
      </div>
    </div>
  );
};
